import { Body } from '@casavo/habitat'
import cn from 'classnames'
import React from 'react'

import Chevron from '@/components/Icon/Chevron'
import { ThisIsACasavoClaim } from '@/components/InventoryBannerBig/ThisIsACasavoClaim'
import { useDevice } from '@/context/Device'
import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'
import { TENANTS } from '@/lib/tenants/constants'
import { Tenants } from '@/lib/tenants/types'
import { backgroundColor, flexCenter, gap } from '@/shared-styles/styles.css'
import { CasavoInventory } from '@/types/listing'

import { Translated } from '../Translated'

import { bannerContainer, chevron } from './styles.css'

type Props = {
  color?: keyof typeof backgroundColor
  i18nKeyLabel: string
  inventory: CasavoInventory
  onClick: VoidFunction
  tenant?: Tenants
}

export const InventoryBannerSmall: React.FC<Props> = ({
  color = 'offWhite',
  i18nKeyLabel,
  inventory,
  onClick,
  tenant = TENANTS.casavo,
}) => {
  const device = useDevice()
  const isMobile = device === 'mobile'
  const isOdaInventory: boolean = inventory === CasavoInventory.Agency

  return (
    <div className={cn(bannerContainer, backgroundColor[color])}>
      <div
        className={cn(
          sprinkles({
            alignItems: 'center',
            display: 'flex',
          }),
          isOdaInventory &&
            sprinkles({
              marginBottom: 'l',
            })
        )}
      >
        <Claim i18nKey={i18nKeyLabel} tenant={tenant} />
        <button
          className={sprinkles({ marginLeft: 'auto', textDecoration: 'underline' })}
          data-testid={'casavo-banner-cta'}
          onClick={onClick}
        >
          <Body noMargin size="s">
            <Translated
              i18Key={
                isMobile
                  ? 'PropertyAdvantages:PropertyAdvantages_Card_CTA'
                  : 'PropertyAdvantages:PropertyAdvantages_CasavoGuarantee_Banner_CTA'
              }
            />
          </Body>
        </button>
        <Chevron className={chevron} />
      </div>
    </div>
  )
}

const Claim: React.FC<{ i18nKey: string; tenant: Tenants }> = ({ i18nKey, tenant }) => {
  switch (tenant) {
    case TENANTS.casavo:
      return <ThisIsACasavoClaim i18nKey={i18nKey} />
    case TENANTS.ucsc:
      return <UCSCClaim i18nKey={i18nKey} />
  }
}

const UCSCClaim: React.FC<{ i18nKey: string }> = ({ i18nKey }) => {
  return (
    <div className={cn(flexCenter, gap.s)}>
      <Body noMargin size="m">
        <Translated i18Key={i18nKey} />
      </Body>
    </div>
  )
}
